import { executePost } from '../common/apiCaller'
import { PostReservationAttachmentDto, PostReservationAttachmentInputDto } from '../dto/reservationAttachmentDto'

const apiNamePublic = 'citizen'
const apiPath = '/reservations/attachment'

export const executePostReservationAttachment = (input: PostReservationAttachmentInputDto) => {
  return executePost<PostReservationAttachmentDto>(apiNamePublic, apiPath, input)
}
